import { SET_IS_ELECTRIC } from '../actions/types';

export default function isElectric(state = '', action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_IS_ELECTRIC:
				if (action.payload) {
					const fuelType = action.payload ?? '';
					const electricTypes = [
						'electric',
						'pure electric',
						'hybrid',
						'plug-in hybrid'
					];

					return electricTypes.some((type) =>
						fuelType.toLowerCase().includes(type)
					);
				}
				return false;

			// no default
		}
	}

	return state;
}
